import { TestimonialsColumn } from "@/components/ui/testimonials-columns-1";
import { motion } from "motion/react";

const testimonials = [
  {
    text: "La membresía me salvó. Ya cambié 3 vidrios y no he pagado nada extra. Total tranquilidad.",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    name: "Carlos Ramírez",
    role: "Miembro Bronce",
  },
  {
    text: "Excelente servicio. Las limpiezas mensuales dejan mi celular como nuevo. 100% recomendado.",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    name: "María Fernanda López",
    role: "Miembro Plata",
  },
  {
    text: "El descuento en accesorios es real. Ya ahorré más de lo que pagué en todo el año.",
    image: "https://randomuser.me/api/portraits/men/67.jpg",
    name: "José Antonio Vargas",
    role: "Miembro Oro",
  },
  {
    text: "La garantía extendida vale oro. Mi teléfono tuvo problemas y lo repararon sin costo.",
    image: "https://randomuser.me/api/portraits/women/28.jpg",
    name: "Ana Gabriela Mora",
    role: "Miembro Plata",
  },
  {
    text: "Atención VIP de verdad. Me responden por WhatsApp en minutos y siempre tienen todo listo.",
    image: "https://randomuser.me/api/portraits/men/52.jpg",
    name: "Roberto Jiménez",
    role: "Miembro Oro",
  },
  {
    text: "Antes gastaba un montón en vidrios. Ahora con la membresía todo está cubierto. ¡Genial!",
    image: "https://randomuser.me/api/portraits/women/63.jpg",
    name: "Sofía Herrera",
    role: "Miembro Bronce",
  },
  {
    text: "Los estuches premium son de muy buena calidad. Y con el descuento de miembro, más accesibles.",
    image: "https://randomuser.me/api/portraits/men/41.jpg",
    name: "Diego Castillo",
    role: "Miembro Plata",
  },
  {
    text: "Llevé a toda mi familia a sacar membresía. El ahorro en grupo es increíble.",
    image: "https://randomuser.me/api/portraits/women/35.jpg",
    name: "Patricia Solano",
    role: "Miembro Oro",
  },
  {
    text: "Reparación express sin filas. Eso solo ya vale la membresía para mí.",
    image: "https://randomuser.me/api/portraits/men/29.jpg",
    name: "Fernando Quesada",
    role: "Miembro Bronce",
  },
];

export const VillatechTestimonialsSection = () => {
  const firstColumn = testimonials.slice(0, 3);
  const secondColumn = testimonials.slice(3, 6);
  const thirdColumn = testimonials.slice(6, 9);

  return (
    <section className="py-20 relative overflow-hidden bg-gradient-to-b from-zinc-900 to-black">
      {/* Glow Background Effects */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/3 left-1/5 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl opacity-30"></div>
        <div className="absolute bottom-1/3 right-1/5 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl opacity-30"></div>
      </div>

      <div className="container z-10 mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          viewport={{ once: true }}
          className="flex flex-col items-center justify-center max-w-[540px] mx-auto"
        >
          <div className="flex justify-center mb-6">
            <div className="border border-blue-500/20 py-2 px-6 rounded-full bg-blue-500/5 backdrop-blur-sm">
              <span className="text-blue-400 font-medium">⭐ Miembros Felices</span>
            </div>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-center mb-6 text-white">
            Lo que dicen <span className="text-blue-400">nuestros miembros</span>
          </h2>
          <p className="text-center text-lg text-zinc-400 max-w-2xl">
            Historias reales de personas que ya están ahorrando con su membresía VillaTech
          </p>
        </motion.div>

        <div className="flex justify-center gap-6 mt-16 [mask-image:linear-gradient(to_bottom,transparent,black_25%,black_75%,transparent)] max-h-[740px] overflow-hidden">
          <TestimonialsColumn testimonials={firstColumn} duration={15} />
          <TestimonialsColumn testimonials={secondColumn} className="hidden md:block" duration={19} />
          <TestimonialsColumn testimonials={thirdColumn} className="hidden lg:block" duration={17} />
        </div>
      </div>
    </section>
  );
};
